import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import DarkMode2 from "components/DarkMode2";

// views

import { useAuth } from "store/auth";
import { ToastContainer } from "react-toastify";

export default function Auth() {
  const { getToken } = useAuth();

  if (getToken()) {
    return <Navigate to="/dashboard" />;
  }
  return (
    <>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <Outlet />
      <DarkMode2 />
    </>
  );
}
